export default __webpack_public_path__ + "static/media/81t.ec6bcb4c.jpg";